import React from 'react';
import ModuleOperationsPage from './ModuleOperationsPage';

const WithdrawalOperationsPage: React.FC = () => (
  <ModuleOperationsPage
    category="withdrawal"
    moduleKey="withdrawal"
    title="Withdrawal Operations"
    description="Withdrawal money movements with the platform's collected fees (visible + hidden) and balance."
  />
);

export default WithdrawalOperationsPage;
